export const bigDesktopDownWidth = 1459
export const smallDesktopDownWidth = 1199
export const tabletDownWidth = 991
export const phonesDownWidth = 767
export const smallPhonesDownWidth = 539

export const bigDesktopUpWidth = 1460
export const smallDesktopUpWidth = 1200
export const tabletUpWidth = 992
export const phonesUpWidth = 768
export const smallPhonesUpWidth = 540

export const bigDesktopDownSize = `${bigDesktopDownWidth}px`
export const smallDesktopDownSize = `${smallDesktopDownWidth}px`
export const tabletDownSize = `${tabletDownWidth}px`
export const phonesDownSize = `${phonesDownWidth}px`
export const smallPhonesDownSize = `${smallPhonesDownWidth}px`

export const smallPhonesUpSize = `${smallPhonesUpWidth}px`
export const phonesUpSize = `${phonesUpWidth}px`
export const tabletUpSize = `${tabletUpWidth}px`
export const smallDesktopUpSize = `${smallDesktopUpWidth}px`
export const bigDesktopUpSize = `${bigDesktopUpWidth}px`

export const bigDesktopDown = `max-width: ${bigDesktopDownSize}`
export const smallDesktopDown = `max-width: ${smallDesktopDownSize}`
export const tabletDown = `max-width: ${tabletDownSize}`
export const phonesDown = `max-width: ${phonesDownSize}`
export const smallPhonesDown = `max-width: ${smallPhonesDownSize}`

export const smallPhonesUp = `min-width: ${smallPhonesUpSize}`
export const phonesUp = `min-width: ${phonesUpSize}`
export const tabletUp = `min-width: ${tabletUpSize}`
export const smallDesktopUp = `min-width: ${smallDesktopUpSize}`
export const bigDesktopUp = `min-width: ${bigDesktopUpSize}`
